// extracted by mini-css-extract-plugin
export default {"coinContainer":"Landing_coinContainer__0iR97","searchInput":"Landing_searchInput__XqNbh"};